<template>
    <div class="header">
        <div class="header-container">
            <b-row class="text-center jcsb" align-v="center">
                <b-col col lg="8">
                    <a href="/affiliates" class="logo"></a>
                    <span class="logo-title">BackOffice</span>
                </b-col>
<!--                <b-col col lg="1">-->
<!--                  -->
<!--                </b-col>-->
                <b-col col lg="3" class="flex right">
                    <div class="notification-icon">
                        <!-- Implement backend for notification feature -->
                        <b-button variant="light" class="btn-icon" id="popover-notification" href="#" tabindex="0">
                            <i class="fas fa-bell"></i>
                            <div class="badge-block" v-if="getAccountNotifications.length > 0">
                                <b-badge variant="primary" class="number">{{ getAccountNotifications.length }}</b-badge>
                            </div>
                        </b-button>
                        <b-popover class="notifications" target="popover-notification" triggers="focus" placement="bottom">
                            <template v-slot:title>Notifications</template>
                            <!-- Filters between Today and Yesterday -->
                            <b-badge href="#" variant="primary">Today</b-badge>
                            <b-badge href="#" variant="secondary">Yesterday</b-badge>
                            <a @click="markAllAsRead" class="mark-read" href="">Mark all as read</a>
                            <!-- No new notifications example -->
                            <div class="notification-list" v-if="!getAccountNotifications || getAccountNotifications.length === 0">
                                <p class="note">No new notifications.</p>
                            </div>
                            <div v-else :class="{ 'notification-list': true, 'extended-block': isNotificationExtended }">
                                <div v-show="!isNotificationExtended" v-for="notification in getAccountNotifications.slice(0, 5)">
                                    <div class="notification-block">
                                        <b-badge variant="primary" class="empty">&nbsp;</b-badge>
                                        <p class="note" v-if="notification.field === 'status'">{{ notification.affiliate_name }} status was changed to {{ notification.new_value }}.</p>
                                        <p class="note" v-else-if="notification.field !== 'status' && notification.new_value === '0'">{{ notification.affiliate_name }} was unassigned from {{ notification.old_value }}.</p>
                                        <p class="note" v-else>{{ notification.affiliate_name }} was assigned to {{ notification.new_value }}.</p>
                                        <p class="time">{{ notification.actionDate }}</p>
                                    </div>
                                </div>

                                <div v-show="isNotificationExtended" v-for="notification in getAccountNotifications">
                                    <div class="notification-block">
                                        <b-badge variant="primary" class="empty">&nbsp;</b-badge>
                                        <p class="note" v-if="notification.field === 'status'">{{ notification.affiliate_name }} status was changed to {{ notification.new_value }}.</p>
                                        <p class="note" v-else-if="notification.field !== 'status' && notification.new_value === '0'">{{ notification.affiliate_name }} was unassigned from {{ notification.old_value }}.</p>
                                        <p class="note" v-else>{{ notification.affiliate_name }} was assigned to {{ notification.new_value }}.</p>
                                        <p class="time">{{ notification.actionDate }}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- Button's action should load all notifications -->
                            <b-button @click="isNotificationExtended = !isNotificationExtended" variant="primary" class="btn-viewmore">
                                View more
                            </b-button>
                        </b-popover>
                    </div>
                    <b-nav>
                        <b-nav-item-dropdown
                                id="my-nav-dropdown"
                                toggle-class="nav-link-custom"
                                right
                        >
                            <template v-slot:button-content>
                            <span class="username">{{getUserName()}}</span>
                            </template>
                            <b-dropdown-item>
                                You are currently signed in as<br>
                                <strong>{{getUserEmail()}}</strong>
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>
                                <router-link class="sign-out" exact to="/logout">
                                    <span @click="loginOut">Sign Out <i class="fad fa-sign-out"></i></span>
                                </router-link>
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-nav>
                    <img class="user-avatar" :src="getUrlAvatar()" />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {getCookie, deleteCookie} from '../../helpers'
import {mapGetters, mapState} from 'vuex'
import store from '../../store'

export default {
	data() {
		return {
			isNotificationExtended: false,

		}
	},
	computed: {
		...mapState('user', ['user']),
		...mapGetters('managers', ['getAccountNotifications'])
	},
	methods: {
		getUrlAvatar() {
			return this.user.length > 0 && this.user[0].picture
		},
		getUserEmail() {
			return this.user.length > 0 && this.user[0].email
		},
		getUserName() {
			return this.user.length > 0 && this.user[0].name
		},
		markAllAsRead(event) {
			event.preventDefault()

			store.dispatch('managers/updateAccountNotificationsStore', { token: getCookie('accessToken'), notifications: this.getAccountNotifications })
		},
		loginOut() {
			deleteCookie('accessToken')
			this.$router.push('/login')
			location.reload()
		}
	},
}
</script>

<style lang="sass">
    span.logo-title
        position: absolute
        top: 57px
        left: 73px
        font-size: 10px
        font-weight: 700
        text-transform: uppercase
        letter-spacing: 6.9px
        opacity: 0.5

    .badge-block
      display: inline

    .notification-list
      max-height: 360px
      overflow: auto

    .extended-block
      max-height: 600px

    .header
        // background: #3A3852
        height: auto
        width: 100%
        position: absolute
        left: 0
        top: 0

        .header-container
            width: 100%
            padding-right: 15px
            padding-left: 15px
            max-width: 95%
            margin: auto

        .logo
            display: block
            width: 200px
            height: 49px
            margin: 20px 0px
            background: url('../../assets/logo.svg') no-repeat
            transition: all 0.5s ease

            &:hover
                cursor: pointer

        .user-avatar
            float: right
            border-radius: 100%
            width: 2.5em
            height: 2.5em
            margin-left: 10px

        .nav
            display: block
            margin-top: 3px
            text-align: right

        .nav-item
            .dropdown-toggle
                white-space: nowrap
                padding: 0
                transition: all 0.5s ease

                span
                    color: #fff
                    font-size: 12px
                    font-weight: 700
                    letter-spacing: 0.5px
                    text-decoration: none
                    line-height: 1rem
                    text-align: right

                    &:hover
                        color: #67E6F5
                        cursor: pointer

                &::after
                    display: inline-block
                    margin-left: 0.255em
                    vertical-align: middle
                    content: ""
                    border-top: 0.2em solid
                    border-right: 0.2em solid transparent
                    border-bottom: 0
                    border-left: 0.2em solid transparent
                    color: rgba(255, 255, 255, 0.5)

        span.user
            float: right

        .dropdown-menu
            text-align: right
            
        .dropdown-menu.dropdown-menu-right.show
            top: 17px !important
            z-index: 99999


        .dropdown-item
            display: block
            width: 100%
            padding: 0.1rem 1rem
            clear: both
            font-size: 14px
            font-weight: 400
            color: #5c6489
            text-align: inherit
            white-space: nowrap
            background-color: transparent
            border: 0

            strong
                color: #3a3852
                font-size: 14px
                font-weight: 700

            &:hover, &:focus
                background-color: transparent

            a
                text-decoration: none

                span
                    color: #3a3852
                    font-size: 12px
                    font-weight: 700
                    letter-spacing: 1px
                    text-decoration: none
                    text-transform: uppercase

                    &:hover
                        color: #36b8e1
                        cursor: pointer


</style>